import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import { useRequest } from 'domain/core/hooks/useRequest';
import { TUpdate } from 'domain/types';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';

export const useUpdateUserRole = (): {
  isLoading: boolean;
  updateUserRole: (body: { roleId: number }) => void;
} => {
  const navigate = useNavigate();
  const globalUpdate: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { isLoading, error, status, send, data } = useRequest({
    url: '/api/v1/auth/me',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
    body: {},
  });

  const updateUserRole = (body: { roleId: number }) => {
    const { roleId } = body;
    if (roleId) {
      send({ role: { id: roleId } });
    }
  };

  if (!error && status === 200) {
    // Check if user has already completed onboarding
    const hasCompletedOnboarding =
      data?.jobSeekerProfile?.hasWorkPreferencesFilled ||
      data?.recruiterProfile?.hasWorkPreferencesFilled;

    navigate('/profile/profile-settings', { replace: true });

    if (hasCompletedOnboarding) {
      // User already completed onboarding, show success modal
      if (update) {
        update({ isOpenProfileCreatedModal: true });
      }
      if (globalUpdate) {
        globalUpdate({ userData: data, isReady: true });
      }
    } else if (globalUpdate) {
      // New user - open onboarding wizard
      globalUpdate({ userData: data, isReady: true, isOpenOnboardingWizard: true });
    }
  }

  return { isLoading, updateUserRole };
};
